import * as LogRocket from "logrocket";

class LogRocketDataSource {
  private readonly appId: string = "hxxjtm/reska";
  public identify(name: string) {
    if (process.env.NODE_ENV !== undefined && process.env.NODE_ENV !== "development") {
      LogRocket.identify(this.appId, {
        name: name
      });
    }
  }
}

export default LogRocketDataSource;
